import Link from "next/link";
import React, { useContext, useEffect, useState } from "react";
import { OutsetaContext } from "../pages/_app";
import FollowCase from "@components/FollowCase";
import Button from "@components/Button";
import IconPlus from "../assets/svgs/plus.svg";
import { Modal } from "react-responsive-modal";
import ModalFollowCase from "@components/ModalFollowCase";

export default function SubNavCase({
  active,
  className,
  hasSources,
  hasTimeline,
  slug,
}) {
  const activeLink = "cursor-default mx-2 px-2 py-2 rounded-lg lg:px-4";
  const inactiveLink =
    "duration-300 mx-2 px-2 py-2 rounded-lg transition-colors hover:text-yellow-400 lg:px-4";

  const { outsetaUserId, addOutsetaUserCaseList, outsetaUserCaseList } =
    useContext(OutsetaContext);

  const [isBtnInView, setIsBtnInView] = useState(true);

  const [signupOpen, setOpenSignup] = useState(false);
  const onOpenModalSignup = () => {
    setOpenSignup(true);
  };
  const onCloseModalSignup = () => {
    setOpenSignup(false);
  };

  useEffect(() => {
    if (window !== "undefined") {

      let isInView = (el) => {
        const box = el?.getBoundingClientRect();
        return box?.top < window?.innerHeight && box?.bottom >= 0;
      };

      window?.addEventListener("scroll", () => {
        let followCaseMain = document?.getElementById("follow-case-btn");
        if (!followCaseMain) return;
        if (isInView(followCaseMain)) {
          setIsBtnInView(true);
        } else {
          setIsBtnInView(false);
        }
      });
    }
  }, []);

  return (
    <nav
      className={`transform bg-white border-b border-t mt-2 px-2 sticky top-0 -translate-y-0.5 ${className} z-40`}
      id={"case-navigation"}
    >
      {/* aria waypoint  */}
      <div className="flex max-w-6xl mx-auto sm:px-2 md:px-4  xl:px-0">
        {slug && (
          <>
            <Link href={`/cases/${slug}`}>
              <a
                className={`py-6 sm:mx-1 relative text-center md:w-1/4 md:mx-auto ${
                  active === "overview"
                    ? `${activeLink} subNavHeaderActive font-semibold`
                    : inactiveLink
                }`}
              >
                Overview
              </a>
            </Link>
            {hasTimeline && (
              <Link href={`/cases/${slug}/#timeline`}>
                <a
                  className={`py-6 sm:mx-1 relative text-center md:mx-auto md:w-1/4 ${
                    active === "timeline"
                      ? `${activeLink} subNavHeaderActive font-semibold`
                      : inactiveLink
                  }`}
                >
                  Timeline
                </a>
              </Link>
            )}
            {hasSources && (
              <Link href={`/cases/${slug}/#sources`}>
                <a
                  className={`py-6 sm:mx-1 relative text-center md:mx-auto md:w-1/4 ${
                    active === "sources"
                      ? `${activeLink} subNavHeaderActive font-semibold`
                      : inactiveLink
                  }`}
                >
                  Sources
                </a>
              </Link>
            )}
          </>
        )}
        {!isBtnInView &&
          (outsetaUserId !== "" ? (
            <FollowCase
              addOutsetaUserCaseList={addOutsetaUserCaseList}
              outsetaUserCaseList={outsetaUserCaseList}
              outsetaUserId={outsetaUserId}
              slug={slug}
              classes={"w-1/4 h-10 my-auto px-2 md:hidden"}
            />
          ) : (
            <>
              <Button
                className="self-center mx-1 px-2 h-px40 ml-auto md:hidden bg-yellow text-white follow-case-tab"
                emphasis="primaryHollow"
                height="32"
                onClick={onOpenModalSignup}
              >
                <IconPlus className="mr-2" width="15" /> Follow
              </Button>

              <Modal
                classNames={{
                  modal: "custom-signup-modal",
                }}
                open={signupOpen}
                onClose={onCloseModalSignup}
                center
              >
                <ModalFollowCase
                  onCloseModalSignup={onCloseModalSignup}
                  slug={slug}
                />
              </Modal>
            </>
          ))}
      </div>
    </nav>
  );
}
